import Dispatch from '@/Http/Dispatch'
import apiConfig from '@/Apis/Apis'
import Axios from "axios";
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig  } from 'axios'
import { message } from 'antd';
import qs from 'qs';
import Store from '@/Store/Store';
import { setToken } from '@/Store/Modules/User';

// init Dispatch
const tunDispatch = new Dispatch({
  apiConfig,
  env: process.env,
  debugData: ""
})

const ERRORMESSAGE = {
  FAIL: "Network request failed",
  OFFLINE: "The network is not connected, please check your network",
};

const Http: AxiosInstance = Axios.create({
  // baseURL: "",
  timeout: 10 * 1000, // set timeout：10s
  headers: {
    Accept: "application/json",
	"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  }
})

Http.defaults.transformRequest = data => {
  return qs.stringify(data)
}

Http.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const url = tunDispatch.getUrl(config.url || "")
  const token = Store.getState().user.token || localStorage.getItem('token')
  config.headers["authentication"] = token

  return {
    ...config,
    url
  };
}, error => {
  return Promise.reject(error);
});

Http.interceptors.response.use(async (response: AxiosResponse) => {
  // do something ...
  const responseStatus = response.data?.status
  if (responseStatus !== 0) {

	if (responseStatus === 401) {
		localStorage.removeItem('token')
		Store.dispatch(setToken(''))
	}
    message.open({
      type: 'warning',
      content: response.data?.message,
    });
    return Promise.reject(response);
  }
  return Promise.resolve(response);
}, error => {
  message.open({
    type: 'warning',
    content: ERRORMESSAGE.FAIL,
  });
  return Promise.reject(error);
});

export { tunDispatch }
export default Http